module.exports = __webpack_public_path__ + "static/media/betterflosspro-2.6ef79c11.jpg";